import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { DECLINE_CANDIDATE, declineCandidate } from '~/actions';
import { useAppSelector, useIsSuccess, useLoading, useToggle } from '~/hooks';
import type { IMultipleCounters } from '~/models/Job';

interface IUseDeclineInterview {
  professionalId: string;
}

export const useDeclineInterview = ({ professionalId }: IUseDeclineInterview) => {
  const dispatch = useDispatch();

  const selectedInterviewIdRef = useRef<string | null>(null);
  const [isOpen, controls] = useToggle();
  const allCandidates = useAppSelector((state) => state.job.allCandidates);

  const { isLoading: isDeclineLoading } = useLoading([DECLINE_CANDIDATE]);
  const { isSuccess, clearSuccess } = useIsSuccess([DECLINE_CANDIDATE]);

  const handleDeclineInterview = (interviewId: string) => {
    selectedInterviewIdRef.current = interviewId;
    controls.setOn();
  };

  const handleConfirmDeclineInterview = () => {
    if (!selectedInterviewIdRef.current) return;
    const counter = allCandidates?.find(
      (c: IMultipleCounters) => c.candidate.id === professionalId,
    );
    if (!counter) return;
    dispatch(
      declineCandidate({
        jobId: selectedInterviewIdRef.current,
        counterOfferId: counter.id,
        cancellation_reason: '',
        candidateId: professionalId,
      }),
    );
  };

  const handleCloseDeclineInterview = () => {
    selectedInterviewIdRef.current = null;
    controls.setOff();
    clearSuccess();
  };

  return {
    isDeclineSuccess: isSuccess,
    isDeclining: isDeclineLoading,
    isOpen,
    selectedInterviewId: selectedInterviewIdRef.current,
    handleCloseDeclineInterview,
    handleConfirmDeclineInterview,
    handleDeclineInterview,
  };
};
